export default "__VITE_ASSET__CsfrYFdX__"